// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMContextService } from '@services/lm-context.service';
import { LMGlobalPersonalization } from '@states/models/lm-global-personalization.model';
import { LMPersonalizationPersistenceService } from '@services/lm-personalization-persistence.service';

class LMGlobalPersonalizationKeyParams {
  public actorId?: string;

  getKey(): string {
    return this.actorId + '_banner';
  }
}

@Injectable()
export class LMGlobalPersonalizationService {
  private personalizationKey: string;

  constructor(
    private lmContextService: LMContextService,
    private lmPersonalizationPersistenceService: LMPersonalizationPersistenceService,
  ) {
  }

  private get key(): string {
    if (!this.personalizationKey) {
      const personalizationKeyParams = new LMGlobalPersonalizationKeyParams();
      personalizationKeyParams.actorId = this.lmContextService.getActorId();
      this.personalizationKey = personalizationKeyParams.getKey();
    }
    return this.personalizationKey;
  }

  public getGlobalPersonalization(): LMGlobalPersonalization {
    return this.lmPersonalizationPersistenceService.getPersonalization(this.key);
  }

  public saveGlobalPersonalization(personalizationItem: LMGlobalPersonalization) {
    this.lmPersonalizationPersistenceService.persistPersonalization(this.key, personalizationItem);
  }

  public deleteGlobalPersonalization(): void {
    return this.lmPersonalizationPersistenceService.removePersonalization(this.key);
  }

  public getAccessibilityMode(): boolean {
    if (this.lmContextService.hasAccessibilityModeParameter()) {
      return this.lmContextService.getAccessibilityModeParameterValue();
    } else {
      return this.getGlobalPersonalization().accessibilityMode;
    }
  }
}
